import { globalTokens } from '@domain-group/design-tokens';
var duration = durationToken => "".concat(globalTokens.motion.duration[durationToken], "ms");
export default duration;